export default {
      id: "icon-news-usage",
      viewBox: "0 0 18 19",
      url: "../icon/" + "icons.svg#icon-news-usage",
      toString: function () {
        return this.url;
      }
    }